// Module
var code = "<mx-search-input value=\"vm.searchText\" on-change=\"vm.search(value)\" debounce=\"1000\" class=\"flex\" label=\"{{::'components.common.searchTextLabel' | mxi18n}}\" data-disabled=\"vm.isDisabled\"></mx-search-input>";
// Exports
export default code;